import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../../common/EnhancedTableHead';
import LinkRouter from '../../../common/LinkRouter';
import ExecutionStatusIcon from '../../executions/ExecutionStatusIcon';
import ExecutionConstants from '../../executions/ExecutionConstants';

interface Props {
  executions: any[];
  familyId: string;
  page: number;
  onPageChange: (newPage: number) => void;
}

const headRows: HeadRow[] = [
  { id: 'id', disablePadding: true, label: 'Execution Id' },
  { id: 'start', disablePadding: false, label: 'Start' },
  { id: 'end', disablePadding: false, label: 'End' },
  { id: 'executionPlan', disablePadding: false, label: 'Execution Plan' },
  { id: 'deploymentResult', disablePadding: false, label: 'Result' }
];

function WorkflowExecutionsTable(props: Props) {
  const { executions, familyId, page, onPageChange } = props;
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('start');
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    onPageChange(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    onPageChange(newPage);
  };

  const sortedRows = sortRows(executions, getSorting(order, orderBy));

  return (
    <div>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                <LinkRouter variant="body1" to={`/families/${familyId}/executions/${row.id}`}>{row.id}</LinkRouter>
              </TableCell>
              <TableCell>
                {moment(row.start).format('MM/DD/YYYY, H:mm:ss')}
              </TableCell>
              <TableCell>
                {isNaN(row.end) ? row.end : moment(row.end).format('MM/DD/YYYY, H:mm:ss')}
              </TableCell>
              <TableCell>{ExecutionConstants.ExecutionPlanLabels[row.executionPlan]}</TableCell>
              <TableCell>
                {row.executionStatus && <Tooltip title={row.executionDescription || ''}>
                  <div>
                    <ExecutionStatusIcon type={row.executionStatus} />
                  </div>
                </Tooltip>}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={executions.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default WorkflowExecutionsTable;
